export { MerchCarousel, type MerchCarouselProps } from './MerchCarousel';
export { merchCarouselSchema } from './schema';
